// Third party
import { combineEpics } from "redux-observable";

// Project
import applicationInitializedEpic from "./applicationInitializedEpic";

export default combineEpics(applicationInitializedEpic);
